import {CUSTOM_ELEMENTS_SCHEMA, NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';

import {IonicModule} from '@ionic/angular';

import {KomponentenPageRoutingModule} from './komponenten-routing.module';

import {KomponentenPage} from './komponenten.page';
// import {MatDatepickerModule, MatFormFieldModule, MatInputModule} from '@angular/material';
// import {OWL_DATE_TIME_LOCALE, OwlDateTimeIntl, OwlDateTimeModule, OwlNativeDateTimeModule} from 'ng-pick-datetime';
import {SopiScrollModule} from '../../sopi/components/sopi-scroll/sopi-scroll.module';

import {TabTestPageModule} from './tab-test/tab-test.module';
import {TabTest2PageModule} from './tab-test-2/tab-test-2.module';
import {TabTest3PageModule} from './tab-test-3/tab-test-3.module';
import {TabTest4PageModule} from './tab-test-4/tab-test-4.module';
import {TabTest5PageModule} from './tab-test-5/tab-test-5.module';
import {SopiComponentsModule} from '../shared/sopi-components/sopi-components.module';
import {ModalTestPageModule} from './modal-test/modal-test.module';
import {SopiDirectivesModule} from '../../sopi/directives/sopi-directives.module';
// import {SopiMaterialModule} from '../sopi-components/sopimaterial.module';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        IonicModule,
        KomponentenPageRoutingModule,
        ModalTestPageModule,
        TabTestPageModule,
        TabTest2PageModule,
        TabTest3PageModule,
        TabTest4PageModule,
        TabTest5PageModule,
        // Wird über SopiComponets geladen
        // MatFormFieldModule,
        // MatInputModule,
        // MatDatepickerModule,
        // OwlDateTimeModule,
        // OwlNativeDateTimeModule,
        SopiComponentsModule.forRoot(),
        SopiDirectivesModule.forRoot(),
        // SopiMaterialModule.forRoot(),
        ReactiveFormsModule,
        SopiScrollModule
    ],
    declarations: [KomponentenPage],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class KomponentenPageModule {
}
